module.exports = {"activation.modal.content.text":"Please wait while we log you in and activate your subscription.","activation.modal.content.status":"Activating"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en/components/ModalContent/Activation.json
// module id = 726
// module chunks = 0